import React, { useEffect, useMemo, useState } from 'react';
import type { LiveBillboardActive } from '../../api/payment/live-effect.api';
import MemberBadge from '../../components/membership/member-badge';
import { formatSecondsLeft } from '../../utils/live-effect';

const POSITION_STYLE: Record<string, React.CSSProperties> = {
  'top-left': { top: 24, left: 24 },
  'top-center': { top: 24, left: '50%', transform: 'translateX(-50%)' },
  'top-right': { top: 24, right: 24 },
  'middle-left': { top: '50%', left: 24, transform: 'translateY(-50%)' },
  'middle-center': {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  'middle-right': { top: '50%', right: 24, transform: 'translateY(-50%)' },
  'bottom-left': { bottom: 24, left: 24 },
  'bottom-center': { bottom: 24, left: '50%', transform: 'translateX(-50%)' },
  'bottom-right': { bottom: 24, right: 24 },
};

/** Giữa hai lần tải từ máy chủ, tự trừ giờ còn lại mỗi 30 giây (overlay đang mở là đang tính giờ). */
export const BILLBOARD_TICK_MS = 30_000;

/** Khung "📌 tên · lời nhắn" + giờ còn lại, luôn hiện ở vị trí streamer chọn, chạy song song hàng đợi hiệu ứng. */
export const Billboard: React.FC<{
  data: LiveBillboardActive;
  position: string;
}> = ({ data, position }) => {
  // Mốc nhận số giờ còn lại từ máy chủ; mỗi lần có số mới thì đếm lại từ mốc mới.
  const receivedAt = useMemo(() => Date.now(), [data]);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), BILLBOARD_TICK_MS);
    return () => window.clearInterval(id);
  }, []);
  const elapsedSec = Math.max(0, Math.floor((now - receivedAt) / 1000));
  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 5,
        maxWidth: '40vw',
        padding: '10px 16px',
        borderRadius: 14,
        background: 'rgba(0,0,0,0.7)',
        color: '#fff',
        font: '600 26px/1.3 system-ui, sans-serif',
        ...(POSITION_STYLE[position] ?? POSITION_STYLE['bottom-left']),
      }}
    >
      <div>
        📌 {data.viewerName}
        {data.isMember && (
          <MemberBadge size={24} className="inline-block ml-1 align-text-bottom" />
        )}{' '}
        · {data.message}
      </div>
      <div style={{ fontSize: 18, opacity: 0.8 }}>
        Còn {formatSecondsLeft(data.secondsLeft - elapsedSec)}
      </div>
    </div>
  );
};
